<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Opciones</h3>
            </div>
          </div>
          <div class="card-body">
            <ValidationObserver v-slot="{ handleSubmit }">
            <form v-if="opciones.length" ref="opcion_form" @submit.prevent="handleSubmit(update)">
              <ValidationProvider name="Porcentaje de abono mínimo" rules="integer|between:0,99" v-slot="{ errors }">
                <base-input
                  label="Porcentaje de abono mínimo"
                  v-model="opciones[0].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              
              <ValidationProvider name="Cantidad de piezas de equipaje gratis" rules="integer|between:0,5" v-slot="{ errors }">
                <base-input
                  label="Cantidad de piezas de equipaje gratis"
                  v-model="opciones[1].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              
              <ValidationProvider name="Cantidad de Horas para empezar a documentar antes de abordaje" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de Horas para empezar a documentar antes de abordaje"
                  v-model="opciones[2].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>

              <ValidationProvider name="Cantidad de Días para facturar después de salida de Sub-Corrida" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de Días para facturar después de salida de Sub-Corrida"
                  v-model="opciones[3].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              
              <ValidationProvider name="Tasa de cambio de Dólares a Pesos" rules="between:1,99|double:2" v-slot="{ errors }">
                <base-input
                  label="Tasa de cambio de Dólares a Pesos"
                  v-model="opciones[5].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>

              <ValidationProvider name="Cantidad de minutos que un asiento está en proceso de venta" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de minutos que un asiento está en proceso de venta"
                  v-model="opciones[6].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              <ValidationProvider name="Cantidad de minutos previo a salida para vender boleto en línea" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de minutos previo a salida para vender boleto en línea"
                  v-model="opciones[8].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              <ValidationProvider name="Cantidad de minutos posterior a salida para vender boleto en taquilla" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de minutos posterior a salida para vender boleto en taquilla"
                  v-model="opciones[10].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              <ValidationProvider name="Número máximo de Piezas de equipaje extra posibles" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Número máximo de Piezas de equipaje extra posibles"
                  v-model="opciones[9].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              <label class="form-control-label">Opción de reservar boletos en pantalla de venta</label>
              <br>
              <base-switch 
              label="Opción de reservar boletos en pantalla de venta"
              class="mr-1" type="default" on-text="Si" off-text="No" v-model="switches.default">
              </base-switch>
              <br><br>
              <ValidationProvider name="Cantidad de Horas para conservar reservas" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de Horas para conservar reservas"
                  v-model="opciones[4].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              <ValidationProvider name="Cantidad de minutos para compra en línea" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de minutos para compra en línea"
                  v-model="opciones[11].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              <ValidationProvider name="Cantidad de horas fuera de tiempo para confirmar salida" rules="integer|between:1,99" v-slot="{ errors }">
                <base-input
                  label="Cantidad de horas fuera de tiempo para confirmar salida"
                  v-model="opciones[12].attributes.valor"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
              <div class="my-4">
                <base-button
                  type="button"
                  class="btn btn-default hover-apolo"
                  native-type="submit"
                >
                  Guardar
                </base-button>
              </div>
            </form>
            </ValidationObserver>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import { ValidationProvider, ValidationObserver,
         extend } from 'vee-validate';
import { between, double, integer } from 'vee-validate/dist/rules';
import ValidationError from "@/components/ValidationError.vue";

extend('integer', { 
  ...integer 
});
extend('between:0,99', {
  ...between
});
extend('between:1,99', {
  ...between
});
extend('between:0,5', {
  ...between
});
extend('double:2', {
  ...double
});

export default {
  layout: "DashboardLayout",

  mixins: [formMixin],

  components: {
    ValidationError,
    ValidationProvider,
    ValidationObserver
  },

  data() {
    return {
      opciones: [],
      loading: true,
      switches: {
          default: false,
        },
    };
  },
  created() {
    this.getOptions();
    /*
    Opciones por posición
    [0] Porcentaje abono minimo
    [1] Cantidad de piezas de equipaje gratis
    [2] Cantidad de Horas para empezar a documentar antes de abordaje
    [3] Cantidad de Días para facturar después de salida de Sub-Corrida
    [4] Cantidad de Horas para conservar reservas // Antes -> Cantidad de Horas para eliminar reservas antes de salida de Sub-Corrida 
    [5] Tasa de cambio de Dólares a Pesos
    [6] Cantidad de minutos que un asiento está en proceso de venta
    [7] Opción de reservar boletos en pantalla de venta
    [8] Cantidad de minutos previo a salida para vender boleto en línea
    [9] Número máximo de Piezas de Equipaje Extra posibles
    [10] Cantidad_minutos_posterior_salida_vender_taquilla
    [11] cantidad_minutos_compra_en_linea
    [12] cantidad_horas_confirmar_salida_fuera_tiempo
    */
  },

  methods: {
    async getOptions() {
      await this.$store.dispatch("opciones/list");
      const opciones = await { ...this.$store.getters["opciones/list"] };
      this.opciones = opciones.data;
      if(this.opciones[7].attributes.valor == 1){
        this.switches.default = true;
      }else{
        this.switches.default = false;
      }
    },
    async update() {
      this.opciones[7].attributes.valor = this.switches.default;
      try {
        await this.$store.dispatch("opciones/update", this.opciones);

        this.$notify({
          type: "success",
          message: "Opciones actualizadas satisfactoriamente.",
          duration: -1
        });
      } catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
        //this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>